import { AUTH_LOGOUT } from '../../../../../common/redux/actions/types/authActionTypes';
import {
  ADD_MANUAL_FLIGHT_REQUEST,
  ADD_MANUAL_FLIGHT_SUCCESS,
  ADD_MANUAL_FLIGHT_FAILURE,
  EDIT_MANUAL_FLIGHT_REQUEST,
  EDIT_MANUAL_FLIGHT_SUCCESS,
  EDIT_MANUAL_FLIGHT_FAILURE,
  GET_ALL_IATA_CODES_SUCCESS,
  DELETE_FLIGHT_REQUEST,
  CLEAR_IATA,
  GET_IATA_CODES_SUCCESS,
  GET_MANUAL_FLIGHT_SUCCESS,
  CLEAR_MANUAL_FLIGHT,
  GET_MANUAL_FLIGHT_REQUEST,
  GET_MANUAL_FLIGHT_FAILURE,
} from '../actions/types/FlightInformationActionTypes';

export const initialState = {
  allIataCodes: [],
  lastRequestStatus: null,
  selectedIATACode: null,
  showManualEntrySelection: null,
  sortedIataCodes: [],
  selectedManualFlight: {},
  manualFlightLoading: false,
};

const FlightInformationReducer = (state = initialState, action) => {
  switch (action.type) {
  case GET_ALL_IATA_CODES_SUCCESS:
    return {
      ...state,
      allIataCodes: action.payload,
    };
  case GET_IATA_CODES_SUCCESS:
    return {
      ...state,
      sortedIataCodes: action.payload,
    };
  case ADD_MANUAL_FLIGHT_REQUEST:
  case EDIT_MANUAL_FLIGHT_REQUEST:
  case DELETE_FLIGHT_REQUEST:
    return {
      ...state,
      lastRequestStatus: null,
      selectedIATACode: action.payload.selectedIATACode,
      showManualEntrySelection: action.payload.showManualEntrySelection,
    };
  case ADD_MANUAL_FLIGHT_SUCCESS:
  case EDIT_MANUAL_FLIGHT_SUCCESS:
    return {
      ...state,
      lastRequestStatus: true,
    };
  case ADD_MANUAL_FLIGHT_FAILURE:
  case EDIT_MANUAL_FLIGHT_FAILURE:
    return {
      ...state,
      lastRequestStatus: false,
    };
  case CLEAR_IATA:
    return {
      ...state,
      selectedIATACode: null,
      showManualEntrySelection: null,
    };
  case GET_MANUAL_FLIGHT_SUCCESS:
  case CLEAR_MANUAL_FLIGHT:
    return {
      ...state,
      selectedManualFlight: action.payload,
      manualFlightLoading: false,
    };
  case GET_MANUAL_FLIGHT_REQUEST:
    return {
      ...state,
      manualFlightLoading: true,
    };
  case GET_MANUAL_FLIGHT_FAILURE:
    return {
      ...state,
      manualFlightLoading: false,
    };
  case AUTH_LOGOUT:
    return initialState;

  default:
    return state;
  }
};

export default FlightInformationReducer;
